import NinjaTable from 'components/tables/NinjaTable';
import React from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import ValueFormatter from 'components/table-formatters/values/ValueFormatter';
import { OwerflowNameFormatter } from 'components/tables/NinjaTable/formatters';
import { NameDefinition } from 'components/NameDefinition';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import { useWidget } from 'components/Widget/useWidget';

const ProductBundlesTable = ({ height, index }) => {
  const { filters } = useWidget();
  const { dates } = useWidgetDate('product_bundles' + index);

  const columns = [
    {
      key: 'original_product_title',
      name: 'Original Product Title',
      resizable: true,
      sortable: true,
      renderCell: ({ row }) => {
        const imgSrc = row?.original_image_url;
        return (
          <OwerflowNameFormatter
            key={row.original_product_id}
            title={row.original_product_title}
            img={imgSrc}
            className='!bg-background-light rounded-md text-xs !font-semibold !h-9 '
          />
        );
      },
      renderSummaryCell: () => 'Totals',
    },
    {
      key: 'bought_with_product_title',
      name: (
        <NameDefinition
          name='Bought With Product Title'
          definiton='Product that is purchased together with the main product in the same order'
        />
      ),
      renderCell: ({ row }) => {
        const imgSrc = row?.bought_with_image_url;
        return (
          <OwerflowNameFormatter
            key={row.bought_with_product_id}
            title={row.bought_with_product_title}
            img={imgSrc}
            className='bg-error-light rounded-md text-xs !font-semibold !h-9'
          />
        );
      },
      sortable: true,
      resizable: true,
    },
    {
      key: 'orders_count',
      width: 240,
      name: (
        <NameDefinition
          name='Orders Count'
          definiton='Number of orders where both products were purchased at the same time.'
        />
      ),
      sortable: true,
      renderCell: ValueFormatter,
      renderSummaryCell: ValueFormatter,
    },
    {
      key: 'orders_original_product',
      width: 240,
      name: (
        <NameDefinition
          name='Orders Original product'
          definiton='Total number of orders in which the original or main product was included.'
        />
      ),
      sortable: true,
      renderCell: ValueFormatter,
    },
    {
      key: 'confidence',
      width: 240,
      name: (
        <NameDefinition
          placement='bottom'
          name='Confidence'
          definiton='This score shows how likely customers are to buy these products together, based on data and shopping patterns. Higher scores indicate a stronger likelihood that these products will sell well as a bundle.'
        />
      ),
      renderCell: ({ row }) => {
        return `${getFormattedNumber(row.confidence)}%`;
      },
    },
  ];

  return (
    <NinjaTable
      columns={columns}
      dataProvider='integrationProductBundles'
      queryParams={{ ...dates, ...filters }}
      cardProps={{ disable: true }}
      maxHeight={height}
      footerProps={{ readOnlyPagination: true }}
      tableProps={{ template: 'widget' }}
    />
  );
};

export default ProductBundlesTable;
